// 🔧 scroll_to_top.js
// ✅ Purpose: Automatically scrolls users to the top of the page
//    whenever the route changes.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const topContent = document.getElementById("top-content");

    if (topContent) {
      topContent.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;